export default __webpack_public_path__ + "static/media/side-effects-lead-in-image.bffb92d4.png";